import React from 'react';
import useLanguageStore from '../../../store/languageStore';
import { trackLanguageChange } from '../../../utils/analytics';
import './language-toggle.css';

class LanguageToggle extends React.Component {
    constructor(props) {
        super(props);
        
        // Get initial state from Zustand store
        this.state = {
            currentLanguage: 'pt',
            currentLabel: 'PT'
        };
    }

    componentDidMount() {
        // Initialize store from localStorage
        const store = useLanguageStore.getState();
        store.initializeFromStorage();
        
        // Get current state from store
        const updatedStore = useLanguageStore.getState();
        this.setState({
            currentLanguage: updatedStore.currentLanguage,
            currentLabel: updatedStore.getCurrentLabel()
        });
        
        // Subscribe to store changes
        this.unsubscribe = useLanguageStore.subscribe((state) => {
            console.log('Language store updated:', state);
            this.setState({ 
                currentLanguage: state.currentLanguage,
                currentLabel: useLanguageStore.getState().getCurrentLabel()
            });
        });
    }

    componentWillUnmount() {
        // Clean up subscription
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    handleLanguageToggle = () => {
        console.log('Language toggle clicked');
        try {
            const store = useLanguageStore.getState();
            console.log('Current store state:', store);
            
            const newLanguage = store.cycleLanguage();
            console.log('Language changed to:', newLanguage);
            
            // Track language change with Google Analytics
            trackLanguageChange(newLanguage);
            
            // Manually update state to ensure UI updates
            const updatedStore = useLanguageStore.getState();
            this.setState({
                currentLanguage: updatedStore.currentLanguage,
                currentLabel: updatedStore.getCurrentLabel()
            });
        } catch (error) {
            console.error('Error cycling language:', error);
        }
    };

    render() {
        console.log('Rendering LanguageToggle with state:', this.state);
        
        return (
            <button 
                className="language-toggle-button"
                onClick={this.handleLanguageToggle}
                title={`Current language: ${this.state.currentLanguage.toUpperCase()}`}
                aria-label={`Switch language. Current: ${this.state.currentLanguage.toUpperCase()}`}
            >
                <span className="language-toggle-label">
                    {this.state.currentLabel}
                </span>
            </button>
        );
    }
}

export default LanguageToggle;